<template>
  <ui-notification-group>
    <ui-notification ref="notificationRef">
      <template #default="{ notifications, close }">
        <ui-notification-message
          v-for="notification in notifications"
          :key="notification.id"
          :notification="notification"
          @added="added(notification.id, close)"
          @close="close(notification.id)"
          @mouseenter="onMouseEnter(notification.id)"
          @mouseleave="onMouseLeave(notification.id, close)"
        />
      </template>
    </ui-notification>
  </ui-notification-group>
</template>

<script setup>
import { onBeforeUnmount, ref } from 'vue';
import UiNotificationGroup from './UiNotificationGroup.vue';
import UiNotification from './UiNotification.vue';
import UiNotificationMessage from './UiNotificationMessage.vue';

const TIMEOUT = 5000;

const notificationRef = ref(null);
const timeouts = ref({});

function added(notificationId, handler) {
  clearTimeout(timeouts.value[notificationId]);
  timeouts.value[notificationId] = setTimeout(() => {
    handler(notificationId);
  }, TIMEOUT);
}

function onMouseEnter(notificationId) {
  clearTimeout(timeouts.value[notificationId]);
}

function onMouseLeave(notificationId, handler) {
  timeouts.value[notificationId] = setTimeout(() => {
    handler(notificationId);
  }, TIMEOUT);
}

onBeforeUnmount(() => {
  // eslint-disable-next-line guard-for-in
  for (const notificationId in timeouts.value) {
    clearTimeout(timeouts.value[notificationId]);
  }
});
</script>
